export const CIP_COLOR_MAPPING = {
  '1': 'tag-color-green-secondary',
  '2': 'tag-color-green-secondary',
  '3': 'tag-color-green',
  '4': 'tag-color-green',
  '5': 'tag-color-yellow',
  '6': 'tag-color-yellow',
  '7': 'tag-color-yellow',
  '8': 'tag-color-red',
  '9': 'tag-color-red',
  '10': 'tag-color-red',
  A1: 'tag-color-green-secondary',
  A2: 'tag-color-green-secondary',
  A3: 'tag-color-green-secondary',
  B1: 'tag-color-green',
  B2: 'tag-color-green',
  B3: 'tag-color-green',
  C1: 'tag-color-yellow',
  C2: 'tag-color-yellow',
  C3: 'tag-color-yellow',
  D1: 'tag-color-red-secondary',
  D2: 'tag-color-red-secondary',
  D3: 'tag-color-red-secondary',
  E1: 'tag-color-red',
  E2: 'tag-color-red',
  E3: 'tag-color-red',
};

export const DD_REGISTRY_MAPPING = {
  0: 'constants_portfolio_ddRegistryMapping_0',
  1: 'constants_portfolio_ddRegistryMapping_1',
  2: 'constants_portfolio_ddRegistryMapping_2',
  3: 'constants_portfolio_ddRegistryMapping_3',
  4: 'constants_portfolio_ddRegistryMapping_4',
};

export const COVID_IMPACT_MAPPING = {
  null: 'covid_impact_title',
  0: 'covid_impact_title_0',
  1: 'covid_impact_title_1',
  2: 'covid_impact_title_2',
  3: 'covid_impact_title_3',
  4: 'covid_impact_title_4',
  5: 'covid_impact_title_5',
};

export const COVID_IMPACT_TOOLTIP_MAPPING = {
  null: 'covid_impact_title_tooltip',
  0: 'covid_impact_title_tooltip_0',
  1: 'covid_impact_title_tooltip_1',
  2: 'covid_impact_title_tooltip_2',
  3: 'covid_impact_title_tooltip_3',
  4: 'covid_impact_title_tooltip_4',
  5: 'covid_impact_title_tooltip_5',
};

export const CIP_TEXT_MAPPING = {
  '101': 'constants_portfolio_cipTextMapping_101',
  '103': 'constants_portfolio_cipTextMapping_103',
  '104': 'constants_portfolio_cipTextMapping_notCalculated',
  X1: 'constants_portfolio_cipTextMapping_notCalculated',
  X2: 'constants_portfolio_cipTextMapping_notCalculated',
  X3: 'constants_portfolio_cipTextMapping_notCalculated',
  X4: 'constants_portfolio_cipTextMapping_notCalculated',
  X5: 'constants_portfolio_cipTextMapping_notCalculated',
  X6: 'constants_portfolio_cipTextMapping_notCalculated',
};

export const CREDIT_CATEGORIES = {
  en: {
    '101': 'Defaulted',
    '103': 'Dissolved',
    '104': 'Not calculated',
  },
  is: {
    '101': 'Í vanskilum',
    '103': 'Brottfellt',
    '104': 'Ekki reiknað',
  },
};
